module.exports = __webpack_public_path__ + "img/sbi.68bf36ff.png";